import Colors from '../../../../constants/Colors'
import { banks } from '../../../../constants/constants'
import PropTypes from 'prop-types'
import { KYC_DECISION, KYC_REASON_BANK, KYC_STATUSES } from '../../constants'
import { Card, Row, Col, Form, Dropdown } from 'react-bootstrap'

const KYCBankForm = ({
  bookBankInfo,
  setUserKYCData,
  decision,
  setDecision,
  reasons,
  setReasons,
  invalid,
  setInvalid,
}) => {
  const handleChangeRadioBank = (e) => {
    setDecision(e.target.value)
    setReasons([])
    if (e.target.value === KYC_STATUSES.APPROVED) {
      setInvalid((prevInvalid) => ({ ...prevInvalid, reasonBank: false }))
    }
  }

  const handleChangeCheckboxBank = (e) => {
    const value = e.target.value
    let updatedItems
    setInvalid((prevInvalid) => ({ ...prevInvalid, reasonBank: false }))
    if (reasons.includes(value)) {
      updatedItems = reasons.filter((item) => item !== value)
    } else {
      updatedItems = [...reasons, value]
    }
    setReasons(updatedItems)
  }

  return (
    <Card
      style={{
        width: '100%',
        borderWidth: '1px',
        borderColor: Colors.LIGHT_GREY2,
      }}
    >
      <Card.Body>
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            overflow: 'hidden',
            height: '300px',
          }}
        >
          <img
            alt=""
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              objectPosition: 'center',
            }}
            src={bookBankInfo.url}
          />
        </div>
        <Form>
          <h4 className="py-2">การตรวจสอบข้อมูลบัญชีธนาคาร</h4>
          <Form.Group>
            {KYC_DECISION.map(({ value, label }) => {
              return (
                <Form.Check
                  key={value}
                  value={value}
                  label={label}
                  type="radio"
                  onChange={handleChangeRadioBank}
                  checked={decision === value}
                  isInvalid={invalid.decisionBank}
                />
              )
            })}
            <Form.Control.Feedback
              type="invalid"
              style={{
                display: invalid.decisionBank ? 'block' : 'none',
              }}
            >
              กรุณาเลือก
            </Form.Control.Feedback>
          </Form.Group>
          {decision === 'APPROVED' && (
            <div>
              <h4 className="py-2">ข้อมูลบัญชีธนาคาร (สำหรับยืนยันตัวตน)</h4>
              <Form.Group as={Row}>
                <Form.Label column sm="3" className="">
                  ธนาคาร :
                </Form.Label>
                <Col sm="9">
                  <Dropdown>
                    <select
                      className="form-control"
                      style={{
                        color: Colors.DARK_GREY,
                      }}
                      onChange={(event) =>
                        setUserKYCData((prev) => ({
                          ...prev,
                          bookBankInfo: { ...prev.bookBankInfo, bankCode: event.target.value },
                        }))
                      }
                      value={bookBankInfo.bankCode}
                    >
                      <option value="" disabled>
                        เลือกธนาคาร
                      </option>
                      {Object.entries(banks).map(([key, value]) => (
                        <option value={key} key={value}>
                          {value}
                        </option>
                      ))}
                    </select>
                  </Dropdown>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="3">
                  เลขที่บัญชี :
                </Form.Label>
                <Col sm="9">
                  <Form.Control
                    type="text"
                    onChange={(event) =>
                      setUserKYCData((prev) => ({
                        ...prev,
                        bookBankInfo: { ...prev.bookBankInfo, accountNo: event.target.value },
                      }))
                    }
                    value={bookBankInfo.accountNo}
                  />
                </Col>
              </Form.Group>
            </div>
          )}
          {decision === 'REJECTED' && (
            <Form.Group>
              <Form.Label>ข้อมูลบัญชีธนาคาร ไม่ถูกต้อง :</Form.Label>
              <Col sm="9">
                {KYC_REASON_BANK.map((reason) => {
                  return (
                    <Form.Check
                      key={reason}
                      value={reason}
                      label={reason}
                      type="checkbox"
                      onChange={handleChangeCheckboxBank}
                      checked={reasons.includes(reason)}
                      isInvalid={invalid.reasonBank}
                    />
                  )
                })}
              </Col>
              <Form.Control.Feedback
                type="invalid"
                style={{
                  display: invalid.reasonBank ? 'block' : 'none',
                }}
              >
                กรุณาเลือกอย่างน้อย 1 รายการ
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </Form>
      </Card.Body>
    </Card>
  )
}

KYCBankForm.propTypes = {
  bookBankInfo: PropTypes.object.isRequired,
  setUserKYCData: PropTypes.func.isRequired,
  decision: PropTypes.string.isRequired,
  setDecision: PropTypes.func.isRequired,
  reasons: PropTypes.array.isRequired,
  setReasons: PropTypes.func.isRequired,
  invalid: PropTypes.object.isRequired,
  setInvalid: PropTypes.func.isRequired,
}

export default KYCBankForm
